import React from 'react';
import AirlineIcon from "@material-ui/icons/FlightLandOutlined";
import {
    Grid,
    FormControl,
    InputLabel,
} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import AutocompleteSelect from "../../../utils/AutocompleteSelect";
// import {appConstants} from "../../../_constants";

const styles = theme => ({
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width: "100%"
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    selectInput: {
        marginTop: "0px",
        width: '100%'
    },
});

const SelectAirlineComponent = ({classes, airlines, AirlineId, selectChange}) => {
    return (
        <div>
            <Grid container spacing={24}>
                <Grid item lg={3}>
                </Grid>
                <Grid item lg={6}>
                    <h1 className={'text-center text-primary'} style={{margin: 0}}>
                        <AirlineIcon style={{fontSize:"60px"}}/>
                    </h1>
                    <h4 className={'text-center'} style={{margin: '0 0 7px'}}>
                        Select airline below
                    </h4>
                    <FormControl
                        className={classNames(classes.selectInput, classes.formControl)}
                    >
                        <InputLabel shrink htmlFor="age-label-placeholder">
                            Airlines
                        </InputLabel>
                        <AutocompleteSelect
                            options={airlines.map(option => ({ value: option.AirlineId, label: option.Airline }))}
                            handleSelectChange={(e, name) => selectChange(e, name)}
                            name={"AirlineId"}
                        />
                        {/*
                        <Select
                            value={AirlineId}
                            onChange={selectChange}
                            input={<Input name="airline" id="airline-label-placeholder" />}
                            // displayEmpty
                            name="AirlineId"
                            className={classes.selectEmpty}
                        >
                            <MenuItem value="-1">Select Airline</MenuItem>
                            {airlines.map((option, i) => (
                                <MenuItem
                                    key={i}
                                    value={option.AirlineId}
                                    className={classes.select}
                                >
                                    {option.Airline}
                                </MenuItem>
                            ))}
                        </Select>
                        */}
                    </FormControl>
                </Grid>
            </Grid>
        </div>
    );
};

export default withStyles(styles)(SelectAirlineComponent);



// WEBPACK FOOTER //
// ./src/views/AirlineRouteSettings/steps/Airline.js